'use client'
import ClientSideContent from 'components/ClientSideContent'

const decodeBase64Values = (obj) => {
  if (!obj || typeof obj !== 'object') {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => decodeBase64Values(item))
  }

  const result = {}
  for (const [key, value] of Object.entries(obj)) {
    if (key === 'value' && typeof value === 'string') {
      try {
        result[key] = Buffer.from(value, 'base64').toString()
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (error) {
        result[key] = value
      }
    } else if (typeof value === 'object') {
      result[key] = decodeBase64Values(value)
    } else {
      result[key] = value
    }
  }

  return result
}

export function ClientSideTypographyClient({
  textContent,
  variantOverride,
  styleOverride,
  TypographyComponent,
  ...props
}) {
  const output = decodeBase64Values(textContent)

  return (
    <ClientSideContent>
      <TypographyComponent
        {...props}
        component="span"
        content={output}
        variantOverride={variantOverride}
        styleOverride={styleOverride}
      />
    </ClientSideContent>
  )
}
